import { render, staticRenderFns } from "./NeoparentSettings.vue?vue&type=template&id=285695ee&scoped=true"
import script from "./NeoparentSettings.vue?vue&type=script&lang=js"
export * from "./NeoparentSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "285695ee",
  null
  
)

export default component.exports